import axios from 'axios'
import Vue from 'vue'
import router from '../router'
import serves from './contanctApi.js'
import '../plugins/element.js'
let instance = axios.create({
    baseURL: 'https://service.zhihuiyijiao.com',
    // baseURL: 'http://192.168.112.32:8081/',// 江西信丰
    timeout: 3600000
})
let httpPopup = new Vue();
const Http = {}
for (var i in serves) {
    let api = serves[i];
    Http[i] = async function (params, isFormData = false, config = {}) {
        let newParams = {};
        if (params && isFormData) {
            newParams = new FormData()
            for (var j in params) {
                newParams.append(j, params[j])
            }
        } else {
            newParams = params
        }
        let response;
        instance.defaults.baseURL = axios.defaults.baseURL
        if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
            try {
                response = await instance[api.method](api.url, newParams, config)
            } catch (err) {
                response = err
            }
        } else if (api.method === 'delete' || api.method === 'get') {
            config.params = newParams;
            try {
                response = await instance[api.method](api.url, config)
            } catch (err) {
                response = err
            }
        }
        return response
    }
}
let loadingItem;
instance.interceptors.request.use(config => {
    loadingItem = httpPopup.$loading({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    config.headers.Authorization = 'Bearer' + window.sessionStorage.getItem('token')
    return config;
}, () => {
    loadingItem && loadingItem.close()
    console.log('请求错误1')
    httpPopup.$message.error('请求失败，请稍后重试')
})
instance.interceptors.response.use(res => {
    loadingItem && loadingItem.close()
    if (res.data.result == 2) {
        router.push({
            path: 'login',
        })
    }

    return res
}, (err) => {
    loadingItem && loadingItem.close()
    console.log('请求错误2', err)
    httpPopup.$message.error('请求失败，请稍后重试')
})
export default Http
